export function initToggleStatusHubspot() {

  $(document).off('click', '.toggle-status').on('click', '.toggle-status', function(event){
    event.stopPropagation();
    const taskId = $(this).data('id')
    const status = $(this).data('status')
    const new_status = (status === 'COMPLETED') ? 'NOT_STARTED' : 'COMPLETED';
    const data = {
        id: taskId,
        status: new_status
    }
    $.ajax({
      url: '/customer_success/change_status_stask',
      method: 'PATCH',
      data: data,
      success: function (response) {
        location.reload()
      },
      error: function (xhr) {
        console.error('Failed to update status task', xhr.responseText)
      },
      complete: function () {
      }
    })
  })

  $(document).off('click', '.task-item').on('click', '.task-item', function(){
    var type = $(this).data('redict-type');
    var id = $(this).data('redict-id');
    
    if(type === "user_company") {
      window.location.href = "/customer_success/ongoing_campaigns?id=" + id;
    } else if(type === "bot") {
      window.location.href = "/bots/" + id;
    }
  });

}